import { useEffect, useState } from "react";
import { Select, message } from "antd";

// Shared "select from a live API" control (quiz-plan.md Section 5.3) — does
// not exist anywhere else in the Builder today. On mount, calls the supplied
// `fetchOptions()` (e.g. GET /pack-categories/lite) and populates a <Select>
// with `{ value: id, label }` options. Stores the real backend id as the
// value — never a name string — so a later admin rename of the source
// record doesn't silently break this reference, unlike today's client-side
// pack-name string-matching this field is meant to replace.
function AsyncSelectField({ value, onChange, fetchOptions, placeholder, size = "small", style }) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        fetchOptions()
            .then((opts) => { if (!cancelled) setOptions(opts); })
            .catch(() => { if (!cancelled) message.error(`Failed to load ${placeholder || "options"}`); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [fetchOptions, placeholder]);

    return (
        <Select
            size={size}
            style={{ minWidth: 160, ...style }}
            // While options are still loading, `options` is empty and AntD
            // has nothing to resolve `value` (a raw id) against — it falls
            // back to rendering the id itself as the label. Withhold value
            // until options are loaded so the field shows its placeholder/
            // loading spinner instead of a flash of the raw id.
            value={loading ? undefined : (value || undefined)}
            onChange={onChange}
            options={options}
            loading={loading}
            allowClear
            showSearch
            optionFilterProp="label"
            placeholder={placeholder || "Select..."}
        />
    );
}

export { AsyncSelectField };
